import { render } from "./developers.vue?vue&type=template&id=2dd54114"
import script from "./developers.vue?vue&type=script&lang=js"
export * from "./developers.vue?vue&type=script&lang=js"

import "./developers.vue?vue&type=style&index=0&id=2dd54114&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__